import React, { Component } from "react";
import "./ContactUs.scss";
function ContactUs() {
  return (
    <div>
      <div className="headersection">
        <h4 className="header">ChromaFan</h4>
      </div>
      <div className="contents">
        <div className="contactUs">
          <h1 className="h1Header">Contact Us</h1>
          <p className="paragraph">Need to get in touch?</p>
          <p className="para">Email support chromafanapp@gmail.com</p>
          <p className="para">and we will get back to you shortly.</p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
